<template>
  <div class="section">
    <!-- put section-specific header/nav/brand here if needed -->
    <router-view />
  </div>
</template>
